import {ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {NgModel} from '@angular/forms';
import {ErrorTemplate} from '../../../models/ErrorTemplate';
import {ValidationHandlerService} from '../validation-handler.service';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';

const DEFAULT_MAX_LENGTH = 2000;

export abstract class AchooInputComponent<T> implements OnInit, OnDestroy {

  @Input()
  public id: string;

  @Input()
  public name: string;

  @Input()
  public formControlName: string;

  @Input()
  public placeholder: string;

  @Input()
  public autocomplete: string;

  @Input()
  public maxlength: number;

  @Input()
  public label: string;

  @Input()
  public labelStyleModifier: string;

  @Input()
  public inputStyleModifier: string;

  @Input()
  public showLabel: boolean;

  @Output()
  modelChange = new EventEmitter<T>();

  @Output()
  keyDownEvent = new EventEmitter<any>();

  @Output()
  keyUpEvent = new EventEmitter<any>();

  @Output()
  enterEvent = new EventEmitter<any>();

  @Output()
  focusEvent = new EventEmitter<any>();
  @Output()
  focusOutEvent = new EventEmitter<any>();

  @Input()
  public disabled: boolean;

  @Input()
  public required: boolean;

  @Input()
  public isPassword: boolean;

  model_: T;

  private _errors: ErrorTemplate[];

  private validationErrorsSubjectSubscription: Subscription;


  constructor(protected validationHandlerService: ValidationHandlerService) {
    this.required = false;

    this.validationErrorsSubjectSubscription = Observable.combineLatest(
      this.validationHandlerService.validationErrorsSubject,
      this.validationHandlerService.validationDisplaySubject
    ).subscribe(this.refreshErrors.bind(this));
  }

  @Input()
  set model(value: T) {
    this.onModelChange(value);
  }

  get model() {
    return this.model_;
  }

  get errors(): any {
    return this._errors;
  }

  @ViewChildren(NgModel)
  inputModelList: QueryList<NgModel>;

  @ViewChild('entryComponent') _entryElement: ElementRef;

  onModelChange(value: T) {
    this._errors = [];
    this.modelChange.emit(value);
    this.model_ = value;
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.validationErrorsSubjectSubscription) {
      this.validationErrorsSubjectSubscription.unsubscribe();
    }
  }

  getMaxLength() {
    return this.maxlength || DEFAULT_MAX_LENGTH;
  }

  onKeyDown(key: KeyboardEvent) {
    this.keyDownEvent.emit(key);
  }

  onKeyUp(event: KeyboardEvent) {
    this.keyUpEvent.emit(event);
  }

  onEnter(event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.enterEvent.emit(event.target);
  }

  onFocus(event: any) {
    this.focusEvent.emit(event);
  }

  onFocusOut(event: any) {
    this.focusOutEvent.emit(event);
  }

  buildChildId() {
    return (this.id || this.name) + '_Child';
  }

  setFocus(): void {
    if (this._entryElement) {
      this._entryElement.nativeElement.focus();
    }
  }

  refreshErrors(results: any[]) {
    const errors: ErrorTemplate[] = results[0];
    const shouldDisplayErrors: boolean = results[1];
    if (shouldDisplayErrors) {
      this._errors = errors.filter(e => e.name === this.name);
    }
  }

  hasErrors(): boolean {
    return this._errors &&
      this._errors.length > 0;
  }

  hasError(): boolean {
    return this._errors &&
      this._errors.findIndex(err => err.name === this.name) >= 0;
  }

  isTouched(): boolean {
    return this.inputModelList.filter(m => !m.touched).length === 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-input/achoo-input.component.ts